import { createGlobalStyle } from 'styled-components'

/**
 * SKE-3793 — overrides that target @dialogueconsulting/sked-preview's own
 * (hashed CSS-module) class names to make its rendering fit the review layout.
 *
 * These are KEPT, not removed: each one patches a sked-preview internal we
 * don't control, so removal is only safe if the corresponding preview element
 * changes upstream. Each selector is documented below. (Full removal is a
 * non-goal — see the issue; dependency/style cleanup is tracked in SKE-3797.)
 */
const GlobalStyle = createGlobalStyle`
  /* Network glyphs: sked-preview's icon-* font classes render oversized in
     this layout — clamp them to 22px. */
  [data-external-review-sked-preview="legacy"] [class^="icon-"],
  [data-external-review-sked-preview="legacy"] [class*=" icon-"] {
    font-size: 22px !important;
  }

  /* Media info icon: sked-preview nudges the svg down; reset to baseline. */
  [data-external-review-sked-preview="legacy"] [class^="Media__InfoIconWrap"] svg {
    top: 0 !important;
  }

  /* LinkedIn preview: widen the document-card row gap, and size the inline
     linkedin glyph + its adjacent label to match the design. */
  [data-external-review-sked-preview="legacy"] [class^="Linkedinstyles__Typography"] {
    ~ div > div > div:not([class^="Media__DocumentInfo"]) {
      gap: 20px;
    }

    [class*=" icon-linkedin"] {
      font-size: 14px !important;

      ~ div {
        font-size: 15px !important;
        font-weight: 500;
      }
    }
  }

  /* Story preview: constrain the link-sticker wrapper and its inner row
     so it doesn't overflow the story frame. */
  [data-external-review-sked-preview="legacy"] [class^="Story__LinkWrapper"] {
    height: 44px !important;

    > a > div {
      height: 28px !important;
    }
  }
`

export default GlobalStyle
